import { SpaceMd, SpaceXs, FontSize100, FontSize300, ColorTextDefault, RadiusMd } from "@nxt-costco-com/forge-design-tokens";
const MAX_CATEGORIES_PER_ROW_DESKTOP = "16.66%";
const MAX_CATEGORIES_PER_ROW_TABLET = `calc(50% - ${SpaceMd})`;
const MAX_CATEGORIES_PER_ROW_MOBILE = "100%";
const containerStyles = {
  borderRadius: RadiusMd,
  flex: { lg: `1 0 ${MAX_CATEGORIES_PER_ROW_DESKTOP}` },
  flexBasis: {
    lg: MAX_CATEGORIES_PER_ROW_DESKTOP,
    md: MAX_CATEGORIES_PER_ROW_TABLET,
    xs: MAX_CATEGORIES_PER_ROW_MOBILE
  }
};
const linkStyles = {
  alignItems: "center",
  color: ColorTextDefault,
  display: "flex",
  flexDirection: "column",
  gap: { lg: 0, md: SpaceMd }
};
const titleStyles = {
  fontSize: { md: FontSize300, xs: FontSize100 },
  margin: { lg: 0, xs: "auto 0" },
  marginTop: SpaceXs,
  paddingLeft: { lg: 0, xs: SpaceMd },
  textAlign: "center",
  wordBreak: "break-word"
};
const imageStyles = {
  height: { lg: "144px", md: "126px", xs: "78px" },
  margin: "auto",
  maxWidth: "100%",
  width: "auto"
};
const adobeSxObj = {
  containerStyles,
  imageStyles,
  linkStyles,
  titleStyles
};
export {
  adobeSxObj
};
